import { render } from "./MapLink.vue?vue&type=template&id=3135ca56"
import script from "./MapLink.vue?vue&type=script&lang=js"
export * from "./MapLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__